// src/pages/EventsPage.js
import React, { useState, useEffect } from "react";
import { db } from "../../firebase";
import { collection, addDoc, getDocs } from "firebase/firestore";
import { Container, Form, Button, Card } from "react-bootstrap";

export default function EventsPage() {
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [description, setDescription] = useState("");
  const [events, setEvents] = useState([]);

  const fetchEvents = async () => {
    const querySnapshot = await getDocs(collection(db, "events"));
    setEvents(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const handleAddEvent = async () => {
    if (!title || !date || !description) {
      alert("Please fill all fields");
      return;
    }
    await addDoc(collection(db, "events"), {
      title,
      date,
      description,
      createdAt: new Date()
    });
    setTitle("");
    setDate("");
    setDescription("");
    fetchEvents();
  };

  return (
    <Container className="mt-4">
     
      <h3>Upcoming Events</h3>
      {events.map(event => (
        <Card key={event.id} className="mb-3">
          <Card.Body>
            <Card.Title>{event.title}</Card.Title>
            <Card.Subtitle>{event.date}</Card.Subtitle>
            <Card.Text>{event.description}</Card.Text>
          </Card.Body>
        </Card>
      ))}
    </Container>
  );
}
